import { render } from "./SendTestEmailModal.vue?vue&type=template&id=5aabedef&scoped=true"
import script from "./SendTestEmailModal.vue?vue&type=script&lang=js"
export * from "./SendTestEmailModal.vue?vue&type=script&lang=js"

import "./SendTestEmailModal.vue?vue&type=style&index=0&id=5aabedef&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aabedef"]])

export default __exports__